import { ReportType, RequestParams, ReportID } from 'app/dataTypes/reports'

import { FinanceReportType } from 'app/dataTypes/reports/finances'

import {
  convertParams as convertParamsCorrections,
  ApiCorrectionsParams,
} from './_predefined/common/corrections'

import {
  convertParams as convertParamsOrdersByClasses,
  ApiOrdersByClassesParams,
} from './_predefined/common/ordersByClasses'

import {
  convertParams as convertParamsSubsidiesGrouped,
  ApiSubsidiesGroupedParams,
} from './_predefined/common/subsidiesGrouped'

import {
  convertParams as convertParamsSubsidiesAct,
  ApiSubsidiesActParams,
} from './_predefined/common/subsidiesAct'

import {
  convertParams as convertParamsSubsidiesDetailed,
  ApiSubsidiesDetailedParams,
} from './_predefined/common/subsidiesDetailed'

import {
  convertParams as convertParamsFinancesSummary,
  ApiFinancesSummaryParams,
} from './_predefined/common/financesSummary'

import {
  convertParams as convertParamsFinancesSummaryReplenishment,
  ApiFinancesSummaryReplenishmentParams,
} from './_predefined/common/financesSummaryReplenishment'

import {
  convertParams as convertParamsFinancesSummaryWriteOff,
  ApiFinancesSummaryWriteOffParams,
} from './_predefined/common/financesSummaryWriteOff'

import {
  convertParams as convertParamsEmoneySales,
  ApiEmoneySalesParams,
} from './_predefined/finances/emoney-sales'

import {
  convertParams as convertParamsEncashments,
  ApiEncashmentsParams,
} from './_predefined/finances/encashments'

import {
  convertParams as convertParamsAverageCheck,
  AverageCheckParamsDto,
} from './_predefined/common/averageCheck'

import { Request } from '../..'

export const dateFormat = 'YYYY-MM-DD'

type ApiResult = {
  report_id: number
  result: 'success'
}

export const convertParams = ({
  formData,
  reportType,
}: RequestParams): [
  (
    | ApiCorrectionsParams
    | ApiOrdersByClassesParams
    | ApiEmoneySalesParams
    | ApiFinancesSummaryParams
    | ApiFinancesSummaryReplenishmentParams
    | ApiFinancesSummaryWriteOffParams
    | ApiEncashmentsParams
    | ApiSubsidiesGroupedParams
    | ApiSubsidiesActParams
    | ApiSubsidiesDetailedParams
    | AverageCheckParamsDto
    | null
  ),
  any,
] => {
  // do common convert params
  if (reportType === ReportType.Corrections) {
    return convertParamsCorrections(formData)
  }
  if (reportType === ReportType.FinancesSummaryWriteOff) {
    return convertParamsFinancesSummaryWriteOff(formData)
  }
  if (reportType === ReportType.FinancesSummaryReplenishment) {
    return convertParamsFinancesSummaryReplenishment(formData)
  }
  if (reportType === ReportType.FinancesSummary) {
    return convertParamsFinancesSummary(formData)
  }
  if (reportType === ReportType.OrdersByClasses) {
    return convertParamsOrdersByClasses(formData)
  }
  if (reportType === FinanceReportType.EmoneySales) {
    return convertParamsEmoneySales(formData)
  }
  if (reportType === FinanceReportType.Encashments) {
    return convertParamsEncashments(formData)
  }
  if (reportType === ReportType.SubsidiesGrouped) {
    return convertParamsSubsidiesGrouped(formData)
  }
  if (reportType === ReportType.SubsidiesAct) {
    return convertParamsSubsidiesAct(formData)
  }
  if (reportType === ReportType.SubsidiesDetailed) {
    return convertParamsSubsidiesDetailed(formData)
  }
  if (reportType === ReportType.AverageCheck) {
    return convertParamsAverageCheck(formData)
  }
  return [null, null]
}

export const convertResult = (data: ApiResult) => {
  const { report_id: reportID } = data
  return String(reportID)
}

export const POST_REPORTS_PERFORM: Request<RequestParams, ReportID, void> = [
  'reports/perform',
  'post',
  ['data'],
]
